import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { gatewayMasterActions } from '../reducers/gateway-master';
import gatewayMasterGateway from '../api/gatewayMasterService';

function* gatewayMasterDataRequest({ payload }: any): any {
  const res = yield call(gatewayMasterGateway.fetchGateways, payload);
  if (res.status === 'success') {
    yield put(gatewayMasterActions.getGatewayDataResponse(res.data));
  } else {
    yield put(gatewayMasterActions.getGatewayDataFailed(res?.code));
  }
}

function* addGatewayMaster({ payload }: any): any {
  const res = yield call(gatewayMasterGateway.addGateway, payload);
  if (res.status === 'success') {
    yield put(gatewayMasterActions.addGatewayResponse(res?.code));
  } else {
    yield put(gatewayMasterActions.addGatewayFailed(res?.code));
  }
}

function* updateGatewayMaster({ payload }: any): any {
  const res = yield call(gatewayMasterGateway.updateGateway, payload);
  if (res.status === 'success') {
    yield put(gatewayMasterActions.updateGatewayResponse(res?.code));
  } else {
    yield put(gatewayMasterActions.updateGatewayFailed(res?.code));
  }
}

function* removeGatewayMaster({ payload }: any): any {
  const res = yield call(gatewayMasterGateway.removeGateway, payload);
  if (res.status === 'success') {
    yield put(gatewayMasterActions.removeGatewayResponse(res?.code));
  } else {
    yield put(gatewayMasterActions.removeGatewayFailed(res?.code));
  }
}

function* gatewayMasterSaga() {
  yield takeLatest('gatewayMaster/getGatewayDataRequest', gatewayMasterDataRequest);
  yield takeLeading('gatewayMaster/addGatewayRequest', addGatewayMaster);
  yield takeLeading('gatewayMaster/removeGatewayRequest', removeGatewayMaster);
  yield takeLeading('gatewayMaster/updateGatewayRequest', updateGatewayMaster);
}

export default gatewayMasterSaga;
